import Papa from "papaparse";
import countryCodesCSV from "../assets/CountryCode.csv";

let countryCodes = [];

// Parse once (only when the module loads)
fetch(countryCodesCSV)
  .then((res) => res.text())
  .then((text) => {
    const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
    countryCodes = parsed.data;
  });

export const toDMS = (decimal, isLat) => {
  const abs = Math.abs(decimal);
  const degrees = Math.floor(abs);
  const minutesFloat = (abs - degrees) * 60;
  const minutes = Math.floor(minutesFloat);
  const seconds = Math.round((minutesFloat - minutes) * 60);

  const direction = isLat
    ? decimal >= 0 ? "N" : "S"
    : decimal >= 0 ? "E" : "W";

  return `${degrees}°${minutes}'${seconds}" ${direction}`;
};

export const getCountryInfo = (address) => {
  if (address === undefined || address === null || address === 0)
    return { name: "Unknown", iso: "xx" };

  const addressNum = Number(address);
  if (isNaN(addressNum)) return null;

  for (const entry of countryCodes) {
    const code = parseInt(entry.Code, 16);
    const length = parseInt(entry.Length, 10);

    if (isNaN(code) || isNaN(length)) continue;

    const comp = addressNum >> (24 - length);

    if (comp === code) {
      return {
        name: entry.CountryName,
        iso: entry.ISO?.toLowerCase() || "",
      };
    }
  }

  return { name: "Unknown", iso: "xx" };
};

export const buildFilter = (f) =>
  `
    invert(${f.invert}%)
    sepia(${f.sepia}%)
    saturate(${f.saturate}%)
    hue-rotate(${f.hue}deg)
    brightness(${f.brightness}%)
    contrast(${f.contrast}%)
  `;

export const getColorFilter = (foe, setOff, filters) => {
  // if (setOff === 0x55)
  //   return "invert(19%) sepia(96%) saturate(6881%) hue-rotate(-15deg) brightness(95%) contrast(104%)";

  // if (setOff === 0xAA)
  //   return "invert(63%) sepia(90%) saturate(745%) hue-rotate(1deg) brightness(104%) contrast(95%)";

  switch (foe) {
    case 20: return buildFilter(filters.enemy);
    case 21: return buildFilter(filters.friendly);
    case 22: return buildFilter(filters.pass);
    case 23:
    default: return buildFilter(filters.unknown);
  }
};

export const getBaseSizeByType = (type) => {
  switch (type) {
    case 500: return 40;
    case 501: return 28;
    case 502: return 24;
    case 503: return 32;
    case 504: return 32;
    default: return 30;
  }
};

export const buildIconStyle = (f) => ({
  filter: `
    brightness(0)
    saturate(100%)
    invert(${f.invert}%)
    sepia(${f.sepia}%)
    saturate(${f.saturate}%)
    hue-rotate(${f.hue}deg)
    brightness(${f.brightness}%)
    contrast(${f.contrast}%)
  `
});

export const rgbToHex = (r, g, b) =>
  "#" +
  [r, g, b]
    .map(x => x.toString(16).padStart(2, "0"))
    .join("");

export const hexToRgbString = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r},${g},${b}`;
};